import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 flex items-center justify-center" data-testid="checkout-cancel-page">
      <div className="text-center max-w-2xl px-6">
        <XCircle className="h-20 w-20 text-muted-foreground mx-auto mb-6" />
        <h1 className="font-serif text-4xl md:text-5xl tracking-tight mb-4" data-testid="cancel-title">
          Payment Cancelled
        </h1>
        <p className="text-base md:text-lg text-muted-foreground mb-8">
          Your payment was cancelled. Your cart has been saved and you can complete your purchase anytime.
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Link to="/cart">
            <Button size="lg" className="rounded-full" data-testid="return-cart-btn">
              RETURN TO CART
            </Button>
          </Link>
          <Link to="/gallery">
            <Button size="lg" variant="outline" className="rounded-full" data-testid="continue-shopping-cancel-btn">
              CONTINUE SHOPPING
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}